import React, { useState } from 'react';
function BMRTable({ formula,bmr, Sedentary, Exercise1_3, Exercise4_5, DailyExercise, IntenseExercise, VeryIntenseExercise}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Besoins caloriques quotidiens totaux:</th>
          <th >Calories (par jour)</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Sédentaire (peu ou pas d'exercice)</td>
          <td>{Sedentary} </td>
        </tr>
        <tr >
          <td>Exercice/sport 1-3 jours par semaine </td>
          <td>{Exercise1_3} </td>
        </tr>
        <tr >
          <td>Exercice/sport 4-5 jours par semaine</td>
          <td>{Exercise4_5} </td>
        </tr>
        <tr >
        <td>
          Exercice quotidien ou exercice intense 3-4 fois par semaine
          </td>
          <td>{DailyExercise} </td>
        </tr>
        <tr >
          <td>Exercice intense/sport 6-7 jours par semaine</td>
          <td>{IntenseExercise} </td>
        </tr>
        <tr >
          <td>
          Exercice extrêmement intense tous les jours ou travail physique
          </td>
          <td>{VeryIntenseExercise} </td>
        </tr>
      </tbody>
    </table>
  );
}
export default BMRTable;